import React, { useState } from "react";
import { Container, Row, Col, Form, } from 'react-bootstrap';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { fetchClassAssignments } from "../Services/AssignmentService";
import Loader from '../Components/Loader';
import ScrollableTable from '../Components/ScrollableTable';
import { Helmet } from "react-helmet-async";

const AssignmentsScreen = () => {
    const [grade, setGrade] = useState('');
    const [classAssignments, setClassAssignments] = useState('');
    const gradeOptions = [
        { value: "", label: "Select Class" },
        { value: "LKG", label: "LKG" },
        { value: "UKG", label: "UKG" },
        { value: "1st", label: "1st" },
        { value: "2nd", label: "2nd" },
        { value: "3rd", label: "3rd" },
        { value: "4th", label: "4th" },
        { value: "5th", label: "5th" },
        { value: "6th", label: "6th" },
        { value: "7th", label: "7th" },
        { value: "8th", label: "8th" },
        { value: "9th", label: "9th" },
        { value: "10th", label: "10th" },
        { value: "11th", label: "11th" },
        { value: "12th", label: "12th" }
    ];

    const handlerClass = async (e) => {
        setGrade(e.target.value);
        const selectedClass = e.target.value;
        await fetchClassAssignments(selectedClass, setClassAssignments);
    }

    return <>
        <div>
            <Helmet>
                <title>Assignments</title>
                <meta name="description" content="This is the Home Page of Oasis Education Institute" />
            </Helmet>
            <Breadcrumbs page="Assignments" label="Home" path="/" />
            <Container style={{ marginTop: '3%', marginBottom: '5%', padding: '20px' }}>
                <div className="flex flex-wrap -mx-2"> 
                    <div className="w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 px-2 ms-2"> 
                        <label className="block p-2"> 
                            <h3 className="text-lg font-bold">Class</h3> 
                        </label>
                        <select
                            onChange={handlerClass}
                            className="block w-full sm:w-1/4 p-3 border border-yellow-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            {gradeOptions.map((item) => (
                                <option value={item.value} key={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div>

                    {!grade ?
                        (<h1 className="text-center text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-4xl m-10 sm:m-15 md:mt-20">
                            Please choose a class to access your assignments!
                        </h1>)
                        : !classAssignments ?
                            (
                                <Container className="d-flex justify-content-center align-items-center p-5  bg-opacity-50 backdrop-blur-sm">
                                    <Loader />
                                </Container>
                            ) :
                            classAssignments.length === 0 ?
                                (<h1 className="text-center text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-4xl m-10 sm:m-15 md:mt-20">
                                    No Assignments found for class {grade} </h1>)
                                : (<>
                                    <ScrollableTable
                                        data={classAssignments}
                                        theads={['Class', 'Subject', 'Title', 'Description', 'Assigned On', 'Submission Date',]}
                                    />

                                </>)}
                </div>
            </Container>
        </div>
    </>;
};

export default AssignmentsScreen;